// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moveable-line {
  position: absolute;
  width: 1px;
  height: 1px;
  background: #FE6100 !important;
  transform-origin: 0px 0.5px; }

.moveable-control {
  width: 8px !important;
  height: 8px !important;
  border-radius: 0px !important;
  background-color: white !important;
  border: 1px solid #FE6100 !important;
  margin-top: -4px !important;
  margin-left: -4px !important; }

.toggle {
  position: relative;
  width: 34px;
  height: 14px;
  border-radius: 15px;
  background-color: #ccc;
  cursor: pointer;
  background-color: #ccc;
  margin: 0 17px; }

.toggle__button {
  position: absolute;
  top: -3px;
  left: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #FE6100;
  transition: transform 0.3s ease-in-out;
  transform: translateX(0);
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2); }

.toggle--on .toggle__button {
  transform: translateX(20px); }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/AddInventoryModal/moveable.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,2BAA2B,EAAA;;AAE/B;EACI,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B,EAAA;;AAGhC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,wBAAwB;EACxB,4GAA4G,EAAA;;AAG9G;EACE,2BAA2B,EAAA","sourcesContent":[".moveable-line {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    background: #FE6100 !important;\n    transform-origin: 0px 0.5px;\n}\n.moveable-control{\n    width: 8px !important;\n    height: 8px !important;\n    border-radius: 0px !important;\n    background-color: white !important;\n    border: 1px solid #FE6100 !important;\n    margin-top: -4px !important;\n    margin-left: -4px !important;\n}\n\n.toggle {\n  position: relative;\n  width: 34px;\n  height: 14px;\n  border-radius: 15px;\n  background-color: #ccc;\n  cursor: pointer;\n  background-color: #ccc;\n  margin: 0 17px;\n}\n\n.toggle__button {\n  position: absolute;\n  top: -3px;\n  left: -2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #FE6100;\n  transition: transform 0.3s ease-in-out;\n  transform: translateX(0);\n  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.toggle--on .toggle__button {\n  transform: translateX(20px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
